import angular from 'angular'
import validationService from './validation.service'

export default angular
  .module('ellipsis.validation', [])
  .service('validationService', validationService)
